import { CrowdctrlListComponent } from '../list/list.component';
/**
 * Theme Switcher Component
 * Reusable component for switching themes
 */

import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonItem, IonLabel, IonRadioGroup, IonRadio } from '@ionic/angular/standalone';
import { ThemeService } from '../../themes/theme.service';
import { getAvailableThemes, getTheme } from '../../themes/theme.config';
import { Subscription } from 'rxjs';
import { ThemePreviewItemComponent } from '../theme-preview-item/theme-preview-item.component';

@Component({
  selector: 'crowdctrl-theme-switcher',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    CrowdctrlListComponent,
    IonItem,
    IonLabel,
    IonRadioGroup,
    IonRadio,
    ThemePreviewItemComponent,
  ],
  templateUrl: './theme-switcher.component.html',
  styleUrl: './theme-switcher.component.css',
})
export class ThemeSwitcherComponent implements OnInit, OnDestroy {
  availableThemes: Array<{
    name: string;
  }> = [];
  currentTheme: string | null = null;
  private themeSubscription?: Subscription;

  constructor(private themeService: ThemeService) {}

  ngOnInit(): void {
    // Get available themes
    const themeNames = getAvailableThemes();
    this.availableThemes = themeNames.map((name) => {
      return { name };
    });

    this.availableThemes.sort((a, b) => {
      const aName = getTheme(a.name)?.displayName || a.name;
      const bName = getTheme(b.name)?.displayName || b.name;
      return aName.localeCompare(bName);
    });

    // Get current theme
    this.currentTheme = this.themeService.getCurrentTheme();

    // Subscribe to theme changes
    this.themeSubscription = this.themeService.currentTheme$.subscribe((theme) => {
      this.currentTheme = theme;
    });
  }

  ngOnDestroy(): void {
    if (this.themeSubscription) {
      this.themeSubscription.unsubscribe();
    }
  }

  onThemeChange(themeName: string): void {
    this.currentTheme = themeName;
    this.themeService.setTheme(themeName);
  }

  getThemeModeLabel(themeName: string): 'Dark Mode' | 'Light Mode' | null {
    const theme = getTheme(themeName);
    if (!theme) return null;
    const baseName = themeName.replace(/-light$|-dark$/, '');
    const hasPair = !!(getTheme(`${baseName}-light`) && getTheme(`${baseName}-dark`));
    if (!hasPair) return null;
    return theme.isDark ? 'Dark Mode' : 'Light Mode';
  }
}
